import { apiClient } from "@/lib/api-client";

export const postValidateUnsurPenunjang = async ({
  niu,
  year,
  semester,
  is_validator,
  payload,
}: {
  niu: string;
  year: number;
  semester: number;
  is_validator: boolean;
  payload: {
    kode_ren: string;
    details: any[];
  };
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const params = new URLSearchParams({
    year: year.toString(),
    semester: semester.toString(),
    niu: niu,
    is_validator: is_validator.toString(),
  });

  const res = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-penunjang/validate?${params.toString()}`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    },
  );

  return res;
};
